import React, { useState } from 'react';
import {
    AppWindow,
    ChevronDown,
    Maximize2,
    MoreHorizontal,
    PanelBottom,
    PanelRight,
    PencilLine,
    Trash2,
} from 'lucide-react';

const NebulaAvatar = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0">
        <circle cx="16" cy="16" r="15.5" fill="#F5F5F5" stroke="#ECECED" />
        <path d="M14 16C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16Z" fill="#3C3C43" />
        <path d="M18 16C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14C17.4477 14 17 14.4477 17 15C17 15.5523 17.4477 16 18 16Z" fill="#3C3C43" />
        <path d="M21.9663 19.5996L23.0988 20.0458C23.1221 20.055 23.1421 20.0711 23.1562 20.0918C23.1703 20.1125 23.1779 20.137 23.1779 20.1621C23.1779 20.1872 23.1703 20.2116 23.1562 20.2324C23.1421 20.2531 23.1221 20.2691 23.0988 20.2783L21.9663 20.7246C21.7658 20.8038 21.5837 20.9234 21.4313 21.0758C21.2789 21.2283 21.1593 21.4104 21.0801 21.6108L20.6338 22.7358C20.6246 22.7591 20.6086 22.7792 20.5878 22.7933C20.5671 22.8073 20.5426 22.8149 20.5176 22.8149C20.4925 22.8149 20.468 22.8073 20.4473 22.7933C20.4265 22.7792 20.4105 22.7591 20.4013 22.7358L19.9551 21.6108C19.876 21.4102 19.7565 21.2281 19.604 21.0756C19.4516 20.9231 19.2694 20.8037 19.0688 20.7246L17.9438 20.2783C17.9205 20.2691 17.9005 20.2531 17.8864 20.2324C17.8723 20.2116 17.8647 20.1872 17.8647 20.1621C17.8647 20.137 17.8723 20.1125 17.8864 20.0918C17.9005 20.0711 17.9205 20.055 17.9438 20.0458L19.0688 19.5996C19.2694 19.5205 19.4516 19.401 19.604 19.2486C19.7565 19.0961 19.876 18.9139 19.9551 18.7133L20.4013 17.5883C20.4105 17.565 20.4265 17.545 20.4473 17.5309C20.468 17.5168 20.4925 17.5093 20.5176 17.5093C20.5426 17.5093 20.5671 17.5168 20.5878 17.5309C20.6086 17.545 20.6246 17.565 20.6338 17.5883L21.0801 18.7133C21.1593 18.9138 21.2789 19.0959 21.4313 19.2483C21.5837 19.4008 21.7658 19.5203 21.9663 19.5996Z" fill="#3C3C43" />
        <path d="M16.0001 20.8002C12.4655 20.8002 9.6001 17.9348 9.6001 14.4002C9.6001 12.6329 11.0328 11.2002 12.8001 11.2002H19.2001C20.9674 11.2002 22.4001 12.6329 22.4001 14.4002C22.4001 14.4002 22.4001 15.6002 22.0001 16.8002" stroke="#3C3C43" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 11.2001V9.6001" stroke="#3C3C43" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const NewChatCircleIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="16" fill="#3C3C43" />
        <path d="M18.5 10.167C21.7217 10.167 24.333 12.7783 24.333 16C24.333 19.2217 21.7217 21.833 18.5 21.833H16L13.5205 24.3135C13.2056 24.6283 12.6673 24.4051 12.667 23.96V21.833H13.5C10.2783 21.833 7.66699 19.2217 7.66699 16C7.66699 12.7783 10.2783 10.167 13.5 10.167H18.5ZM16 13C15.7239 13 15.5 13.2239 15.5 13.5V15.5H13.5C13.2239 15.5 13 15.7239 13 16C13 16.2761 13.2239 16.5 13.5 16.5H15.5V18.5C15.5 18.7761 15.7239 19 16 19C16.2761 19 16.5 18.7761 16.5 18.5V16.5H18.5C18.7761 16.5 19 16.2761 19 16C19 15.7239 18.7761 15.5 18.5 15.5H16.5V13.5C16.5 13.2239 16.2761 13 16 13Z" fill="white" />
    </svg>
);

const CloseCircleIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#ECECED" />
        <path d="M21.6569 10.3434L10.3431 21.6571M21.6569 21.6571L10.3431 10.3434" stroke="#3C3C43" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const ShareIcon = ({ size = 13 }) => (
    <svg
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        className="flex-shrink-0"
    >
        <path d="M9.5 3.00017C9.77607 3.00017 9.99988 3.22413 10 3.50017C10 3.77631 9.77614 4.00017 9.5 4.00017H6C4.89551 4.00017 4.00012 4.8957 4 6.00017V14.0002C4 15.1047 4.89543 16.0002 6 16.0002H14C15.1046 16.0002 16 15.1047 16 14.0002V12.5002C16.0001 12.2241 16.2239 12.0002 16.5 12.0002C16.7761 12.0002 16.9999 12.2241 17 12.5002V14.0002C17 15.657 15.6569 17.0002 14 17.0002H6C4.34315 17.0002 3 15.657 3 14.0002V6.00017C3.00012 4.34342 4.34322 3.00017 6 3.00017H9.5ZM13.2969 2.04314C13.4771 1.96307 13.6883 1.9962 13.835 2.1281L18.835 6.6281C18.9402 6.72287 18.9999 6.85853 19 7.00017C19 7.14184 18.9402 7.27742 18.835 7.37224L13.835 11.8722C13.6883 12.0042 13.4772 12.0373 13.2969 11.9572C13.1165 11.8768 13 11.6976 13 11.5002V9.34001C11.5991 9.46822 10.3347 10.1196 9.2998 10.9484C8.28552 11.7608 7.52484 12.7163 7.10547 13.4328L6.94727 13.7238C6.84356 13.9312 6.61045 14.0398 6.38477 13.9865C6.15932 13.9331 6 13.7319 6 13.5002C6.00003 11.4519 6.38155 9.21589 7.51855 7.47673C8.60929 5.80864 10.3673 4.64331 13 4.51286V2.50017L13.0049 2.42693C13.0297 2.25945 13.1392 2.11338 13.2969 2.04314ZM14 5.00017C14 5.27631 13.7761 5.50017 13.5 5.50017C10.9125 5.50017 9.3231 6.54551 8.35645 8.02361C7.67097 9.07197 7.28309 10.3631 7.11035 11.7072C7.54278 11.1873 8.06932 10.6531 8.6748 10.1681C9.94307 9.1524 11.6004 8.3156 13.5 8.3156C13.776 8.3156 13.9998 8.53962 14 8.8156V10.3761L17.751 7.00017L14 3.62321V5.00017Z" />
    </svg>
);
import { useChatPlatform } from '../../context/ChatPlatformContext';
import { useSessions } from '../../store/hooks';
import ShareModal from '../../../components/ShareModal';
import { ASSISTANT_MODES, MODE_LABELS } from '../config/modes';

const MODE_ICONS = {
    [ASSISTANT_MODES.FLOATING]: AppWindow,
    [ASSISTANT_MODES.SIDEBAR]: PanelRight,
    [ASSISTANT_MODES.FULLSCREEN]: Maximize2,
    [ASSISTANT_MODES.DOCK]: PanelBottom,
};

const SWITCHABLE_MODES = [
    ASSISTANT_MODES.FULLSCREEN,
    ASSISTANT_MODES.SIDEBAR,
    ASSISTANT_MODES.FLOATING,
    ASSISTANT_MODES.DOCK,
];

const getSessionId = (session) => session?.session_id || session?.id;
const getSessionName = (session) => session?.session_name || session?.name || 'Untitled';

const IconButton = ({ onClick, label, children, className = '' }) => (
    <button
        type="button"
        onClick={onClick}
        aria-label={label}
        title={label}
        className={`p-1.5 rounded hover:bg-gray-100 text-gray-600 ${className}`}
    >
        {children}
    </button>
);

export default function AssistantFrame({
    mode,
    onModeChange,
    onMinimize,
    showMinimize = true,
    showModeSwitcher = true,
}) {
    const [historyOpen, setHistoryOpen] = useState(false);
    const [modeOpen, setModeOpen] = useState(false);
    const [moreOpen, setMoreOpen] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const {
        activeSessionId,
        chatCallbacksRef,
        hasRightPanelContent,
        isRightPanelOpen,
        setIsRightPanelOpen,
    } = useChatPlatform();
    const sessions = useSessions();

    const activeSession = sessions.find((s) => getSessionId(s) === activeSessionId);
    const activeSessionName = activeSession ? getSessionName(activeSession) : null;
    const ModeIcon = MODE_ICONS[mode] || AppWindow;

    const handleNewChat = () => {
        chatCallbacksRef?.current?.handleNewChat?.();
    };

    const handleSwitchSession = (sessionId) => {
        setHistoryOpen(false);
        chatCallbacksRef?.current?.switchSession?.(sessionId);
    };

    const handleRename = () => {
        setMoreOpen(false);
        if (!activeSessionId) return;
        const currentName = activeSessionName || '';
        const next = window.prompt('Đổi tên phiên chat', currentName);
        if (next && next.trim() && next !== currentName) {
            chatCallbacksRef?.current?.handleRenameSession?.(activeSessionId, next.trim());
        }
    };

    const handleDelete = () => {
        setMoreOpen(false);
        if (!activeSessionId) return;
        if (!window.confirm('Xoá phiên chat này?')) return;
        chatCallbacksRef?.current?.handleDeleteSession?.(activeSessionId);
    };

    const togglePanel = () => {
        setMoreOpen(false);
        setIsRightPanelOpen(!isRightPanelOpen);
    };

    const handleShare = () => {
        setMoreOpen(false);
        if (!activeSessionId) return;
        setShowShareModal(true);
    };

    if (mode === ASSISTANT_MODES.FRAMLESS) return null;

    return (
        <div className="flex items-center justify-between gap-2 h-14 px-3 bg-app-bg border-b border-[#ECECED]">
            <div className="flex items-center gap-2 min-w-0 flex-1">
                <NebulaAvatar />
                <div className="relative min-w-0 flex flex-col justify-center gap-[3px] h-9">
                    <div className="text-[13px] font-semibold text-gray-900 leading-[1.1] truncate">Nebula Assistant</div>
                    <button
                        type="button"
                        onClick={() => setHistoryOpen((v) => !v)}
                        title="Lịch sử chat"
                        className="inline-flex items-center gap-1 max-w-full text-[11px] leading-[1.1] text-gray-500 hover:text-gray-700 truncate"
                    >
                        <span className="truncate">
                            {activeSessionName || 'Chưa có tiêu đề'}
                        </span>
                        <ChevronDown size={11} className="flex-shrink-0" />
                    </button>
                    {historyOpen && (
                        <>
                            <div className="fixed inset-0 z-40" onClick={() => setHistoryOpen(false)} />
                            <div className="absolute left-0 top-full mt-1 w-64 max-h-80 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg z-50 py-1">
                                {sessions.length === 0 ? (
                                    <div className="px-3 py-2 text-xs text-gray-400">Chưa có phiên chat</div>
                                ) : (
                                    sessions.slice(0, 100).map((s) => {
                                        const id = getSessionId(s);
                                        return (
                                            <button
                                                key={id}
                                                type="button"
                                                onClick={() => handleSwitchSession(id)}
                                                className={`block w-full text-left px-3 py-1.5 text-xs truncate hover:bg-gray-100 ${id === activeSessionId ? 'text-gray-900 font-medium bg-gray-50' : 'text-gray-600'}`}
                                            >
                                                {getSessionName(s)}
                                            </button>
                                        );
                                    })
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-1.5 flex-shrink-0">
                <button
                    type="button"
                    onClick={handleNewChat}
                    aria-label="Chat mới"
                    title="Chat mới"
                    className="rounded-full flex-shrink-0 hover:opacity-90 transition-opacity"
                >
                    <NewChatCircleIcon />
                </button>

                {showModeSwitcher && (
                <div className="relative">
                    <button
                        type="button"
                        onClick={() => setModeOpen((v) => !v)}
                        aria-label={`Chế độ: ${MODE_LABELS[mode]}`}
                        title={`Chế độ: ${MODE_LABELS[mode]}`}
                        className="w-8 h-8 rounded-full border border-[#ECECED] bg-white flex items-center justify-center text-[#3C3C43] hover:bg-gray-50 transition-colors"
                    >
                        <ModeIcon size={14} />
                    </button>
                    {modeOpen && (
                        <>
                            <div className="fixed inset-0 z-40" onClick={() => setModeOpen(false)} />
                            <div className="absolute right-0 top-full mt-1 min-w-[160px] bg-white border border-gray-200 rounded-md shadow-lg z-50 py-1">
                                {SWITCHABLE_MODES.map((m) => {
                                    const Icon = MODE_ICONS[m];
                                    return (
                                        <button
                                            key={m}
                                            type="button"
                                            onClick={() => {
                                                setModeOpen(false);
                                                if (m !== mode) onModeChange?.(m);
                                            }}
                                            className={`flex items-center gap-2 w-full px-3 py-1.5 text-xs hover:bg-gray-100 ${m === mode ? 'text-gray-900 font-medium' : 'text-gray-600'}`}
                                        >
                                            <Icon size={13} />
                                            {MODE_LABELS[m]}
                                        </button>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
                )}

                {activeSessionId && (
                    <div className="relative">
                        <button
                            type="button"
                            onClick={() => setMoreOpen((v) => !v)}
                            aria-label="Thêm"
                            title="Thêm"
                            className="w-8 h-8 rounded-full border border-[#ECECED] bg-white flex items-center justify-center text-[#3C3C43] hover:bg-gray-50 transition-colors"
                        >
                            <MoreHorizontal size={14} />
                        </button>
                        {moreOpen && (
                            <>
                                <div className="fixed inset-0 z-40" onClick={() => setMoreOpen(false)} />
                                <div className="absolute right-0 top-full mt-1 min-w-[180px] bg-white border border-gray-200 rounded-md shadow-lg z-50 py-1 text-xs text-gray-700">
                                    <button
                                        type="button"
                                        onClick={handleShare}
                                        className="flex items-center gap-2 w-full px-3 py-1.5 hover:bg-gray-100"
                                    >
                                        <ShareIcon size={13} /> Chia sẻ
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleRename}
                                        className="flex items-center gap-2 w-full px-3 py-1.5 hover:bg-gray-100"
                                    >
                                        <PencilLine size={13} /> Đổi tên
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleDelete}
                                        className="flex items-center gap-2 w-full px-3 py-1.5 hover:bg-gray-100 text-red-600"
                                    >
                                        <Trash2 size={13} /> Xoá phiên
                                    </button>
                                    {hasRightPanelContent && (
                                        <>
                                            <div className="border-t border-gray-100 my-1" />
                                            <button
                                                type="button"
                                                onClick={togglePanel}
                                                className="flex items-center gap-2 w-full px-3 py-1.5 hover:bg-gray-100"
                                            >
                                                <PanelRight size={13} />
                                                {isRightPanelOpen ? 'Ẩn panel' : 'Hiện panel'}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                )}

                {showMinimize && (
                    <button
                        type="button"
                        onClick={onMinimize}
                        aria-label="Thu nhỏ"
                        title="Thu nhỏ"
                        className="rounded-full flex-shrink-0 hover:bg-gray-50 transition-colors"
                    >
                        <CloseCircleIcon />
                    </button>
                )}
            </div>

            {showShareModal && activeSessionId && (
                <ShareModal
                    isOpen={showShareModal}
                    onClose={() => setShowShareModal(false)}
                    shareType="session"
                    targetId={activeSessionId}
                    defaultTitle={activeSessionName || 'Chat Session'}
                />
            )}
        </div>
    );
}
